module.exports = __webpack_public_path__ + "static/media/koryu_es_00000.491a2ebb.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/koryu_es_00000.png
// module id = 194
// module chunks = 0